<template>
  <v-card class="pa-4">
    <title>Cheminfomatics Modules media materials</title>
    <div class="mt-2 mb-3">
      The Cheminformatics Modules is a set of prototype modules which are using a compilation of information sourced
      from many sites, databases and sources including U.S. Federal and state sources and international bodies that
      saves the user time by providing information in one location. We understand that you may have questions, concerns
      and comments and encourage you to reach out to members of the team.
    </div>
    <b-tabs v-model="currentTab">
      <b-tab
        title="Manuals"
        active
      >
        <ServicesList
          :headers="headers"
          :services="manuals"
        />
      </b-tab>
      <b-tab title="Videos">
        <ServicesList
          :headers="headers"
          :services="videos"
        />
      </b-tab>
      <b-tab title="Presentations">
        <ServicesList
          :headers="headers"
          :services="presentations"
        />
      </b-tab>
      <b-tab title="Publications">
        <ServicesList
          :headers="headers"
          :services="publications"
        />
      </b-tab>
    </b-tabs>
  </v-card>
</template>

<script>
import FeaturesBase from '@/components/FeaturesBase'
import ServicesList from '@/components/ServicesList.vue'

export default {
  components: { ServicesList },
  mixins: [FeaturesBase],

  data() {
    return {
      currentTab: 0,
      headers: [
        { text: 'Name', value: 'title' },
        { text: 'Module', value: 'module' },
        { text: 'Description', value: 'description', sortable: false },
      ],
      manuals: [
        {
          title: 'Navigation',
          module: 'General',
          description: `Welcome and Navigation`,
          url: '/manuals/welcome/WelcomeandNavigation.html',
          target: 'manual',
        },
        {
          title: 'Basic Searching',
          module: 'General',
          description: `Searching to populate the chemical cart before using all modules`,
          url: '/manuals/cart/BasicSearchingtoFilltheCart.html',
          target: 'manual',
        },
        {
          title: 'Hazard Module',
          module: 'Hazard',
          description: `Profiling chemicals based on Hazard Data`,
          url: '/manuals/hazard/HazardProfiling.html',
          target: 'manual',
        },
        {
          title: 'Search Module',
          module: 'Search',
          description: `Structure, substructure and similairty searching`,
          url: '/manuals/search/SearchModule.html',
          target: 'manual',
        },
        {
          title: 'Safety Module',
          module: 'Safety',
          description: `Profiling chemicals based on Safety Data`,
          url: '/manuals/safety/SafetyModule.html',
          target: 'manual',
        },
      ],
      videos: [
        {
          title: 'Filling the Chemical Cart',
          module: 'General',
          description: `Searching to populate the chemical cart before using all modules`,
          url: 'https://youtu.be/jAC8l8zdH4E',
          target: 'video',
        },
        {
          title: 'Generating a Hazard Profile: Part 1',
          module: 'Hazard',
          description: `Create a hazard profile for a batch of chemicals, review and interrogate, and download the resulting report`,
          url: 'https://youtu.be/gYrxS1yA7N4',
          target: 'video',
        },
        {
          title: 'Generating a Hazard Profile: Part 2',
          module: 'Hazard',
          description: `Creating a report and filtered views including emergency response and site specific screening views`,
          url: 'https://youtu.be/_pTgxE5B16c',
          target: 'video',
        },
        {
          title: 'Predicting transformation products',
          module: 'Hazard',
          description: `Generate a hazard profile for predicted transformation products from EPA's Chemical Transformation Simulator`,
          url: 'https://youtu.be/vxsDr4AZc0o',
          target: 'video',
        },
        {
          title: 'Generating a Safety Profile',
          module: 'Safety',
          description: `Create a safety profile for a batch of chemicals and download the resulting report`,
          url: 'https://youtu.be/_yn22ih5lp0',
          target: 'video',
        },
        {
          title: 'Structure, substructure and similarity searching',
          module: 'Search',
          description: `Searching chemical substances using structure, substructure and similarity searching `,
          url: 'https://youtu.be/gYrxS1yA7N4',
          target: 'video',
        },
        {
          title: 'ChemFunCT Taxonomy',
          module: 'AMOS',
          description: `Chemical Functional Use Taxonomy directed graph demo `,
          url: 'https://www.youtube.com/watch?v=vfH6XbiATgg',
          target: 'video',
        },
      ],
      presentations: [
        {
          title: 'Presentation on AMOS',
          module: 'AMOS',
          description: `Using cheminformatics to develop a structure searchable database of analytical methods`,
          url: 'https://www.slideshare.net/slideshow/plying-cheminformatics-to-develop-a-structure-searchable-database-of-analytical-methods/266855992',
          target: 'presentation',
        },
        {
          title: 'ACS Agrochemical Division Webinar',
          module: 'AMOS',
          description: `Training Workshop for the New AMOS Database`,
          url: 'https://www.youtube.com/watch?v=6BTLm-rmQyw',
          target: 'presentation',
        },
        {
          title: 'FDA Cheminformatics Workshop',
          module: 'AMOS',
          description: `AMOS: the EPA database of analytical methods and open mass spectral database supporting non-targeted analysis`,
          url: 'https://www.slideshare.net/slideshow/amos-the-epa-database-of-analytical-methods-and-open-mass-spectral-database-supporting-nontargeted-analysis/262546570',
          target: 'presentation',
        },
      ],
      publications: [
        {
          title: 'JoVE journal article',
          module: 'AMOS',
          description: `Journal of Visual Experiments:  Applying Cheminformatics to Develop a Structure Searchable Database of Analytical Methods`,
          url: 'https://www.jove.com/t/68194/applying-cheminformatics-to-develop-structure-searchable-database',
          target: 'publication',
        },
        {
          title: 'Data aggregation for the Hazard Module',
          module: 'Hazard',
          description: `An automated framework for compiling and integrating chemical hazard data`,
          url: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC8048128/',
          target: 'publication',
        },
      ],
    }
  },
}
</script>
